module.exports = __webpack_public_path__ + "static/img/precision_course_logo.6c2f921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/common/img/precision_course_logo.png
// module id = LhwF
// module chunks = 1